class LoginForm extends AjaxForm {
    constructor() {
        super();
        this.email = this.querySelector('[name="customer[email]"]');
        this.password = this.querySelector('[name="customer[password]"]');
        this.errorMessage = this.querySelector(".form__message.custom_error");
        this.content = this.querySelector(".content_wrapper");
        this.promo = this.querySelector(".custom_success");
        this.submit = this.querySelector("#login-submit-button");
        this.errorSummary = this.querySelector('#error-summary'); 
    }

    connectedCallback() {
        if (this.submit) {
            this.submit.addEventListener("click", (e) => this.onSubmit(e));
        } else {
            console.error("Submit button not found");
        }

        if (this.formSubmitted()) {
            this.hideForm();
        }
    }

    formSubmitted() {
        const params = new URLSearchParams(window.location.search);
        return params.get("customer_posted") === "true";
    }

    hideForm() {
        this.content.style.display = "none";
    }

    showPromo() {
        this.promo.style.display = "flex";
    }

    hideMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "none";
        }
    }

    showMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "flex";
        }
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    showErrorIcon(field) {
        const errorIcon = field.parentElement.querySelector('.error-icon');
        if (errorIcon) {
            errorIcon.style.display = 'block';
        }
    }

    updateErrorSummary(errors) {
        if (errors.length > 0) {

            this.errorSummary.innerHTML = `
                <ul class="visually-hidden">
                    ${errors.map(error => `<li>${error}</li>`).join('')}
                </ul>
            `;
            this.errorSummary.setAttribute('role', 'alert');
            this.errorSummary.setAttribute('aria-live', 'assertive'); 
            this.errorSummary.classList.remove('visually-hidden');
            this.errorSummary.focus(); 
        } else {
            this.errorSummary.classList.add('visually-hidden');
            this.errorSummary.innerHTML = '';
        }
    }

    onSubmit(e) {
        // e.preventDefault(); 
        this.hideMailError();

        let isValid = true;
        let errors = [];

        this.querySelectorAll('.tw-error-message').forEach(el => el.textContent = '');
        this.querySelectorAll('.fieldinput').forEach(el => {
            el.classList.remove('tw-error-border');
            el.querySelector("input")?.removeAttribute("aria-invalid");
            el.querySelector(".error-icon").style.display = 'none';
        });

        const errorEmail = this.querySelector('#login-email-error');
        if (!this.email.value.trim()) {
            isValid = false;
            errorEmail.textContent = errorEmail.dataset.loginError;
            this.email.closest('.fieldinput').classList.add('tw-error-border');
            this.email.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.email);
            errors.push(errorEmail.dataset.loginError);
        } else if (!this.isValidEmail(this.email.value.trim())) {
            isValid = false;
            errorEmail.textContent = errorEmail.dataset.loginErrorRequired;
            this.email.closest('.fieldinput').classList.add('tw-error-border');
            this.email.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.email);
            errors.push(errorEmail.dataset.loginErrorRequired);
        }

        const errorPassword = this.querySelector('#login-password-error');
        if (this.password && !this.password.value.trim()) {
            isValid = false;
            errorPassword.textContent = errorPassword.dataset.loginError;
            this.password.closest('.fieldinput').classList.add('tw-error-border');
            this.password.setAttribute("aria-invalid", "true");
            this.showErrorIcon(this.password);
            errors.push(errorPassword.dataset.loginError);
        }

        this.updateErrorSummary(errors);

        if (isValid) {
            window.location.hash = "login";
            this.querySelector('form').submit();
            localStorage.setItem('is-user-login', 'true');
        }
    }
}

customElements.define("login-form", LoginForm);